import { z } from "zod";
import type { Enums } from "../../types";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

export const WarehouseZoneTypes: Array<Enums<"warehouseZoneType">> = [
	"storage",
	"consolidation",
	"receiving",
	"shipping",
	"staging",
] as const;

/**
 * Where a load carrier goes once it leaves this zone, or null where the chain ends.
 *
 * A zone naming a follow-up is what raises the next transport order when a carrier is dropped
 * off here, so the chain is walked one hop at a time rather than planned as a route. Null is an
 * ordinary answer and the common one: a shipping zone is where goods stop being the warehouse's
 * problem.
 *
 * The database refuses a chain that closes into a loop, so a value accepted here is one a
 * carrier can actually reach the end of.
 */
export const warehouseZoneFormSchema = z.object({
	name: z.string(),
	description: z.string().nullish(),
	type: z.enum(WarehouseZoneTypes),
	followUpZoneId: ZodStringNullable,
});

export type WarehouseZoneFormSchema = z.infer<typeof warehouseZoneFormSchema>;
